<template>
  <div class="flex flex-col gap-6">
    <HorizontalSeparator class="mt-6"/>
    <h2 class="text-3xl font-bold text-blue">Please enter your company name:</h2>

    <div class="flex flex-row gap-4">
      <div class="flex w-5/6">
        <div
            class="hidden md:flex items-center w-52 bg-grey-15 border border-grey-25 px-4 border-r-0 rounded-l text-sm text-grey-90"
        >
          Company Name
        </div>
        <InputText
            class="rounded-l md:rounded-l-none rounded-r text-grey-90"
            :error="errors.hasOwnProperty('formFields.employerName')"
            :error-message="getErrorMessage(errors, 'formFields.employerName')"
            :value="employerNameValue"
            name="employerName"
            placeholder="Enter company name"
            rows="6"
            @change="
            (event) =>
              $emit('changeParameter', {
                key: 'employerName',
                value: event.target.value,
              })
          "
        />
      </div>

      <template v-if="shouldShowSkipButton">
        <div
            class="hidden md:block cursor-pointer text-xl text-grey-70 underline"
            @click="$emit('skipForm')"
        >
          Skip this step
        </div>
      </template>
    </div>

    <div>
      <InputButton style-type="contact-form" @click="submitForm">
        <template v-if="isWebSite">
          Visit Website
        </template>
        <template v-else>
          Display Telephone Number
        </template>
      </InputButton>
    </div>

    <template v-if="shouldShowSkipButton">
      <div
          class="block md:hidden cursor-pointer text-xl text-grey-70 underline"
          @click="$emit('skipForm')"
      >
        Skip this step
      </div>
    </template>

    <div>
      <h3 class="text-2xl font-bold text-blue py-4">
        Q. Why we ask for your company name?
      </h3>
      <p class="text-base text-grey-70">
        A. If you contact an agency, it helps them to know where you found their
        details.<br/>
        You WILL NOT be asked to leave your own name or any contact information.
      </p>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState, mapActions} from 'vuex';
import InputButton from 'Components/InputButton';
import InputText from 'Components/InputText';
import {getErrorMessage} from 'Helpers/helpers';
import HorizontalSeparator from "Components/HorizontalSeparator.vue";

export default {
  name: 'ContactEmployerDetailsForm',
  components: {
    HorizontalSeparator,
    InputButton,
    InputText,
  },
  props: {
    errors: {
      type: Object,
      default() {
        return {};
      },
    },
    employerName: {
      type: String,
    },
  },
  computed: {
    ...mapState('contact', ['contactFormType']),
    ...mapGetters('contact', ['shouldShowSkipButton']),
    isWebSite() {
      return this.contactFormType === 'website' ? true : false
    },
    isTelFax() {
      return this.contactFormType === 'telfax' ? true : false
    },
    employerNameValue() {
      return this.employerName !== 'null' && this.employerName !== null
          ? this.employerName
          : '';
    }
  },
  methods: {
    ...mapActions('contact', ['registerContact']),
    getErrorMessage,
    submitForm() {
      this.registerContact()
          .then((response) => {
            console.log('Form Submitted Successfully', response);
            this.$emit('submitForm');
          })
          .catch((error) => {
            console.error('Error submitting form', error);
          })
      ;
    }

  },
  mounted() {
    console.log('// EMIT: submitPreregister');
    this.$emit('submitPreregister');
  },
};
</script>
  